import { defineStore } from 'pinia'

export const useNotefieIdStore = defineStore('notefieID', {
  state: () => ({
    notefieID: '' as string,
    siteLocation: '' as string,
    siteLocationNotefieID: '' as string,
    allNotefieIDs: [] as Array<any>
  }),
  actions: {},
  persist: true
})
